import { getSocket } from '@src/App';

export default async (tournamentId: string) => {
  try {
    const message: { tournamentId: string } = { tournamentId };
    getSocket().emit('leaveTournament', message);
  } catch (e) {
    console.log(e);
  }
};
